import { Button } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import PropTypes from "prop-types";

/**
 * Header component for passkeys section with count display and add button
 * @param {Object} props - Component props
 * @param {number} props.count - Current number of passkeys
 * @param {number} props.maxCount - Maximum allowed number of passkeys
 * @param {Function} props.onAddClick - Callback function when add button is clicked
 * @param {boolean} [props.isLoading=false] - Whether component is in loading state
 * @returns {JSX.Element} Rendered passkeys header
 */
const PasskeysHeader = ({ count, maxCount, onAddClick, isLoading = false }) => {
  const hasPasskeys = count > 0;

  return (
    <div className="passkeys-header">
      <div className="passkeys-header-copy">
        <h2 className="passkeys-title">
          Passkeys ({count}/{maxCount})
        </h2>
        {hasPasskeys ? (
          <p className="passkeys-description mb-0">
            Your current passkeys are listed below.
          </p>
        ) : (
          <p className="passkeys-description mb-0">
            No passkeys configured yet.
            <br />
            Create a passkey to sign in faster using your face, fingerprint or
            PIN.
          </p>
        )}
      </div>
      <Button
        variant="warning"
        className="racq-primary-btn"
        size="sm"
        onClick={onAddClick}
        disabled={count >= maxCount || isLoading}
      >
        <FaPlus
          className="me-1"
          style={{
            height: 12,
            width: 12,
            verticalAlign: "baseline",
          }}
        />
        Add passkey
      </Button>
    </div>
  );
};

PasskeysHeader.propTypes = {
  count: PropTypes.number.isRequired,
  maxCount: PropTypes.number.isRequired,
  onAddClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default PasskeysHeader;
